import React from 'react'
import styled from 'styled-components'
import { useRouter } from 'next/router'
import {
  Link,
  LocalLabelsProvider,
  useGlobalLabels,
  useLogout,
} from '@sentecacommerce-theme/lib'
import { Typography, Button } from '../Common'
import {
  AccountSettings,
  NavigationSkeleton,
  Subscriptions,
  UpdatePassword,
  GDPR,
  AddressBook,
  BillingAddress,
  Wallet,
  OrderHistory,
} from './Components'
import { ProfileLabels, ProfileProps } from './profile.props'

export type { ProfileProps }

export const Profile = ({ navigation, profileLabels }: ProfileProps) => {
  const router = useRouter()
  const logout = useLogout()

  const { myProfile, backToShop } = profileLabels?.general
  const { signs } = useGlobalLabels()
  const tabs = {
    'personal-info': <AccountSettings />,
    subscriptions: <Subscriptions />,
    gdpr: <GDPR />,
    ordercard: <Wallet />,
    'update-password': <UpdatePassword />,
    'address-book': <AddressBook />,
    'billing-addresses': <BillingAddress />,
    'order-history': <OrderHistory />,
  }

  return (
    <LocalLabelsProvider<ProfileLabels> labels={profileLabels}>
      <Container>
        <HeaderContainer>
          <Title>{myProfile}</Title>
          <Link href="/" passHref>
            <BackToShop>{`${signs?.lessThan} ${backToShop}`}</BackToShop>
          </Link>
        </HeaderContainer>
        <Inner>
          {navigation.map((item) => {
            if (item.url === 'logout') {
              return (
                <Button
                  className="mt-3"
                  variant="grey"
                  borderRadius="small"
                  onClick={() => {
                    logout()
                    router.push('/')
                  }}
                >
                  {item.label}
                </Button>
              )
            }

            return (
              <NavigationSkeleton
                url={item.url}
                header={item.label}
                key={item.url}
              >
                {tabs[item.url] || null}
              </NavigationSkeleton>
            )
          })}
        </Inner>
      </Container>
    </LocalLabelsProvider>
  )
}

const Container = styled.div.attrs({
  className: 'container pt-5 mt-4 mb-5 pb-5',
})``

const Inner = styled.div.attrs({
  className: '',
})``

const BackToShop = styled.a`
  text-decoration: underline;

  &:hover {
    opacity: 0.7;
  }
`
const HeaderContainer = styled.div.attrs({
  className: 'd-md-flex mb-5',
})`
  justify-content: space-between;
  align-items: center;
`

const Title = styled(Typography).attrs({
  as: 'h1',
  className: 'mb-3 mb-md-0',
  variant: 2,
})`
  font-weight: normal;
`
